import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { MeteringPointsEffects } from '@appStore/metering-points/effects/metering-point.effects';
import { MeteringPointGroupsEffects } from '@appStore/metering-points/effects/metering-point-group.effects';
import { AgreementEffects } from '@appStore/metering-points/effects/agreement.effects';

export const effects = [MeteringPointsEffects, MeteringPointGroupsEffects, AgreementEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class MeteringPointsEffectsModule {}
